module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.af7ae505.af7ae505.woff2";